import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import { isNumeric } from "../../../../../../helpers/dataHelpers";
import { getPricingName, getPricingDataById } from "../../../../../../components/helper/helper";

function KurvPricing({ appData }) {
  
  return (
    <>
      <ul>
        <li>
          <div>
            <p>Pricing model</p>
            <p>{getPricingName(appData.qualifiedtype)}</p>
          </div>
        </li>
      </ul>

      {/* Surcharge Rates */}
      <div>
        {/* <HeadingWithLine text="Pin-Based Debit" /> */}
        <ul>
          <li>
            <div>
              <p>Kurv Swiped Rate</p>
              <p>{getPricingDataById(appData, 58).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Kurv Swiped Txn Fee</p>
              <p>$ {getPricingDataById(appData, 58).dollars}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Kurv Keyed Rate</p>
              <p>{getPricingDataById(appData, 59).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Kurv Keyed Txn Fee</p>
              <p>$ {getPricingDataById(appData, 59).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Amex */}

      {
        (isNumeric(getPricingDataById(appData, 60).percent) &&
          getPricingDataById(appData, 60).percent > 0 &&
          isNumeric(getPricingDataById(appData, 60).dollars) &&
          getPricingDataById(appData, 60).dollars > 0)
          ? (
            <div>
              <HeadingWithLine text="Amex" />
              <ul>
                <li>
                  <div>
                    <p>Kurv Amex Rate</p>
                    <p>{getPricingDataById(appData, 60).percent}%</p>
                  </div>
                </li>
                <li>
                  <div>
                    <p>Kurv Amex Txn Fee</p>
                    <p>$ {getPricingDataById(appData, 60).dollars}</p>
                  </div>
                </li>
              </ul>
            </div>

          ) : (
            <div>
              <HeadingWithLine text="Amex" />
              <ul>
                <li>
                  <div>
                    <p>Kurv Amex Rate</p>
                    <p>Amex Rate Disabled</p>
                  </div>
                </li>
              </ul>
            </div>
          )
      }

      {/* Pin Based Debit */}
      <div>
        <HeadingWithLine text={`Pin-Based Debit${appData?.billing?.network_fee === "no" ? " (Disabled)" : ""}`} />
        <ul>
          <li>
            <div>
              <p>Network Fee</p>
              <p>{appData?.billing?.network_fee == 'yes' ? "Yes" : "No"}</p>
            </div>
          </li>
        </ul>
        <ul>
          <li>
            <div>
              <p>Kurv Pin Debit Rate</p>
              <p>{getPricingDataById(appData, 5).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Kurv Pin Debit Per Txn</p>
              <p>$ {getPricingDataById(appData, 5).dollars}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

export default KurvPricing;
